import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Divider,
  Flex,
  Grid,
  GridCol,
  Select,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconActivity,
  IconBuilding,
  IconBuildingStore,
  IconCheck,
  IconEdit,
  IconHandClick,
  IconCircleCheck,
  IconCircleOff,
  IconHandStop,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconTrash,
  IconUserCircle,
  IconUserCode,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { _localization } from "../../config/location";

import { MessageResponse } from "../../model/MessageResponse";
import "../../Styles/tab.component.css";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import { EmployeeModel } from "../../model/Employee";
import { useDebouncedState } from "@mantine/hooks";
import EmployeeEdit from "./EmployeeEdit";
import GroupAddInventoryAuth from "./GroupAddInventoryAuth";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { AvatarUtils } from "../../common/ColorByName/AvatarUtils";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import {
  getBranchSelect,
  getTblDepartmentSelect,
  getTblDmEmployeeSelect,
  getTblRoleSelect,
} from "../../service/getSelectApi";
import EmployeeDetail from "./EmployeeDetail";
import { green } from "../../const/variables";
import InputSearch from "../../common/InputSearch/InputSearch";
import EmployeeCreate from "./EmployeeCreate";
import { WorkShiftDetail } from "../../model/WorkShift";

type Props = {
  isOpenModal?: boolean;
  handleAssignNv?: (id: number) => void;
  setWorkShiftDetails?: any;
  workShiftDetails?: WorkShiftDetail[];
};
const EmployeeModelView = ({
  isOpenModal,
  handleAssignNv,
  setWorkShiftDetails,
  workShiftDetails,
}: Props) => {
  //#region  table
  const headerRef = React.useRef<HTMLDivElement>(null);
  //data and fetching state
  const [data, setData] = useState<EmployeeModel[]>([]);
  const [isError, setIsError] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  // const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: workShiftDetails ? 50 : 20,
  });
  //count
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [dataDepartment, setDataDepartment] = useState<ComboboxItem[]>([]);
  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [dataRole, setDataRole] = useState<ComboboxItem[]>([]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<
    WorkShiftDetail[]
  >([]);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const sizeGridModal = { base: 12, sm: 6, md: 6, lg: 3 };

  const [search, setSearch] = useDebouncedState(
    {
      roleId: "",
      departmentId: "",
      managerId: "",
      branchId: "",
      keySearch: "",
    },
    300
  );

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    setDataEmployeeSelect(workShiftDetails ?? []);
  }, [workShiftDetails]);

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  // useEffect(() => {
  //   if (workShiftDetails) {
  //     handleChangeSearchValue("1293", "departmentId");
  //     handleChangeSearchValue("2721", "branchId");
  //     fetchData();
  //   }
  // }, [search.departmentId, workShiftDetails]);

  const fetchDataEmployee = async () => {
    const response = await getTblDmEmployeeSelect();
    setDataEmployee(
      response.map((employee) => ({
        value: employee.value,
        label: employee.text,
      }))
    );
  };

  const fetchDataRole = async () => {
    const response = await getTblRoleSelect();
    if (workShiftDetails) {
      const mappedData = response
        .filter(
          (item) =>
            item.value != null &&
            item.text != null &&
            item.value !== "-1" &&
            item.text?.toLowerCase()?.includes("kinh doanh online")
        )
        .map((item) => ({
          value: item.value,
          label: `${item.text}`,
        }));
      setDataRole(mappedData);
    } else {
      const mappedData = response
        .filter(
          (item) =>
            item.value != null && item.text != null && item.value !== "-1"
        )
        .map((item) => ({
          value: item.value,
          label: `${item.text}`,
        }));
      setDataRole(mappedData);
    }
  };

  const fetchDataBranch = async () => {
    const getDataBranch = await getBranchSelect();

    const mappedData = getDataBranch
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataBranch(mappedData);
  };

  const fetchDataDepartment = async () => {
    const getDataDepartment = await getTblDepartmentSelect();

    const mappedData = getDataDepartment
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataDepartment(mappedData);
  };

  const fetchData = async () => {
    //  setIsLoading(true);
    // setIsRefetching(true);
    let url = `&Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.roleId) {
      url += `&RoleId=${search.roleId}`;
    }

    if (workShiftDetails || isOpenModal) {
      url += `&DepartmentId=1293`;
    } else if (search.departmentId) {
      url += `&DepartmentId=${search.departmentId}`;
    }

    if (search.managerId) {
      url += `&ManagerId=${search.managerId}`;
    }

    if (workShiftDetails) {
      url += `&BranchId=2721`;
    } else if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }
    try {
      const response = await repositoryPos.get<
        MessageResponse<EmployeeModel[]>
      >(
        `/api/v1/TblDmEmployee/get-list?Active=${
          workShiftDetails ? true : false
        }${url}`
      );
      if (response && response.success) {
        setData(response.data ?? []);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    //  setIsError(false);
    // setIsLoading(false);
    //  setIsRefetching(false);
  };

  const activeData = async (status: boolean) => {
    if (selectIds.length < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryPos.post<MessageResponse<boolean>>(
          "/api/v1/TblDmEmployee/actives",
          {
            ids: selectIds,
            status: status,
          }
        );
        console.log(res);
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          await fetchData();
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };
  const activesData = async (status: boolean, id: string) => {
    if (!id || id.length < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryPos.post<MessageResponse<boolean>>(
          "/api/v1/TblDmEmployee/actives",
          {
            ids: [id],
            status: status,
          }
        );
        console.log(res);
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          await fetchData();
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };
  const deletesData = async (ids: string[]) => {
    if (ids.length < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Bạn có thực sự muốn xóa ?</Title>
            </>
          ),

          size: "400px",
          labels: { confirm: "Xác nhận", cancel: "Hủy bỏ" },
          onConfirm: async () => {
            const res = await repositoryPos.post<MessageResponse<boolean>>(
              "/api/v1/TblDmEmployee/delete",
              ids
            );
            if (res)
              if (res.success) {
                NotificationExtension.Success("Xóa thành công !");
                await fetchData();
              } else NotificationExtension.Fails("Xóa thất bại !");
          },
          classNames: {
            title: "custom-modal-title",
            body: "custom-modal-body",
          },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa !</Title>
        </>
      ),
      size: "1000px",
      children: <EmployeeEdit id={id} onLoad={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm mới !</Title>
        </>
      ),
      size: "650px",
      children: <EmployeeCreate onLoad={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function detailItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết !</Title>
        </>
      ),
      size: "850px",
      children: <EmployeeDetail id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function getColorStatus(text: boolean) {
    switch (text) {
      case true:
        return "teal";
      default:
        return "red";
    }
  }

  function getGender(text: number) {
    switch (text) {
      case 0:
        return "";
      case 1:
        return "green";
      default:
        return "gray";
    }
  }
  function getGenderText(text: number) {
    switch (text) {
      case 0:
        return "Nam";
      case 1:
        return "Nữ";
      default:
        return "Không xác định";
    }
  }
  const groupAddInventoryModal = (idEmp: number) => {
    modals.closeAll();

    modals.openConfirmModal({
      title: "Danh sách kho theo chi nhánh",

      size: "80%",
      fullScreen: false,
      children: (
        <GroupAddInventoryAuth idAuthozire={idEmp}></GroupAddInventoryAuth>
      ),
      labels: { confirm: "Confirm", cancel: "Hủy bỏ" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  function formatDate(isoDateString: string): string {
    const date: Date = new Date(isoDateString);

    // Cộng thêm 7 tiếng
    date.setHours(date.getHours() + 7);
    // Lấy các thành phần ngày giờ sau khi cộng thêm số giờ
    const hours: string = date.getHours().toString().padStart(2, "0");
    const minutes: string = date.getMinutes().toString().padStart(2, "0");
    const seconds: string = date.getSeconds().toString().padStart(2, "0");
    const day: string = date.getDate().toString().padStart(2, "0");
    const month: string = (date.getMonth() + 1).toString().padStart(2, "0"); // Tháng bắt đầu từ 0
    const year: number = date.getFullYear();

    // Định dạng thành chuỗi "giờ:phút:giây ngày-tháng-năm"
    return `${day}-${month}-${year}`;
  }

  const updateTools = async () => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/sync-asia",
      {
        type: "",
        title: "",
        status: 0,
        detail: "",
        instance: "",
        additionalProp1: "",
        additionalProp2: "",
        additionalProp3: "",
      }
    );

    if (res && res?.success) {
      NotificationExtension.Success("Đồng bộ thành công");
      setTimeout(() => {
        fetchData();
      }, 2500);
    } else {
      NotificationExtension.Fails("Đồng bộ thất bại !");
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<EmployeeModel>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "code",
        header: "Mã nhân viên",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "fullname",
        header: "Tên nhân viên",
        size: 250,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <AvatarUtils
              value={row.original.fullname?.toString().split("-")[0]}
            />
          </>
        ),
      },
      {
        accessorKey: "email",
        header: "Email",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "departmentName",
        header: "Phòng ban",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "roleName",
        header: "Chức vụ",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "gender",
        header: "Giới tính",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getGender(row.original.gender)}>
              {getGenderText(row.original.gender)}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "phoneNumber",
        header: "Điện thoại",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "dateOfBirth",
        header: "Ngày sinh",
        Cell: ({ renderedCellValue, row }) => (
          <>
            {renderedCellValue &&
              formatDate(renderedCellValue?.toLocaleString() ?? "")}
          </>
        ),
      },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        //  enableGrouping: true,
        //   size: 50,
      },

      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(row.original.active ?? false)}>
              {row.original.active ? "Đang hoạt động" : "Dừng hoạt động"}
            </Badge>
          </>
        ),
      },

      {
        accessorKey: "description",
        header: "Ghi chú",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "accountingCenterId",
        header: "Id trung tâm hạch toán",
        size: 225,
      },

      {
        accessorKey: "managerName",
        header: "Người quản lý trực tiếp",
        size: 225,
        Cell: ({ renderedCellValue, row }) => (
          <>
            {renderedCellValue && renderedCellValue?.toString().split("-")[0]}
          </>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },

      {
        accessorKey: "action",
        header: "Thao tác",
        size: 120,
        enableResizing: false,
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {/* <Tooltip label="Nhóm">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={() => {
                  groupAddRoleModal(row.original.id.toString());
                }}
              >
                <IconFunction size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
            {/* <Tooltip label="Kho theo chi nhánh">
              <ActionIcon
                onClick={() => {
                  groupAddInventoryModal(row.original.id);
                }}
                variant="light"
                aria-label="Settings"
                color="indigo"
              >
                <IconBuildingWarehouse size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
            {!isOpenModal && (
              <>
                <Tooltip label="Chỉnh sửa">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="orange"
                    onClick={async () => {
                      editItem(row.original.id);
                    }}
                  >
                    <IconEdit size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>

                <Tooltip
                  label={
                    row.original.active === true
                      ? "Dừng hoạt động"
                      : "Hoạt động"
                  }
                >
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color={row.original.active === true ? "red" : "teal"}
                    onClick={async () => {
                      await activesData(
                        !row.original.active,
                        row.original.id.toString()
                      );
                    }}
                  >
                    {/* Biểu tượng nói việc sẽ xảy ra khi bấm, không phải trạng thái hiện tại:
                        đang hoạt động thì hiện dấu cấm để dừng,
                        đang dừng thì hiện dấu tích để bật lại */}
                    {row.original.active === true ? (
                      <IconCircleOff size={20} />
                    ) : (
                      <IconCircleCheck size={20} />
                    )}
                  </ActionIcon>
                </Tooltip>
              </>
            )}

            {isOpenModal && !workShiftDetails && (
              <Button
                variant="filled"
                onClick={() =>
                  handleAssignNv && handleAssignNv(row.original.id)
                }
                color="blue"
                size="sm"
              >
                Chọn
              </Button>
            )}

            {workShiftDetails &&
              (dataEmployeeSelect?.some(
                (item) => item.empid === row.original.id
              ) ? (
                <Button
                  variant="filled"
                  color="teal"
                  onClick={() => {
                    deleteSelectEmp(row.original.id);
                  }}
                >
                  Đã chọn
                </Button>
              ) : (
                <Button
                  variant="filled"
                  color="blue"
                  onClick={() =>
                    setDataEmployeeSelect((prev: WorkShiftDetail[]) => [
                      ...prev,
                      {
                        id: 0,
                        select: false,
                        shiftId: 0,
                        empid: row.original.id,
                        empcode: row.original.code,
                        empname: row.original.fullname,
                        quanity: 0,
                        attribute1: "A",
                        attribute2: row.original.departmentId?.toString(),
                        attribute3: row.original.departmentName?.toString(),
                        attribute4: row.original.roleId?.toString(),
                        attribute5: row.original.roleName?.toString(),
                        attribute6: "",
                        attribute7: "",
                        attribute8: "",
                        attribute9: "",
                        attribute10: "",
                      },
                    ])
                  }
                >
                  Chọn
                </Button>
              ))}
            {/* <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  await deletesData([row.original.id.toString()]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
          </Box>
        ),
      },
    ],
    [dataEmployeeSelect]
  );

  const [height, setHeight] = useState(0);

  const deleteSelectEmp = (id: number) => {
    const deleteData = dataEmployeeSelect?.filter((item) => item.empid !== id);
    setDataEmployeeSelect(deleteData);
  };

  const checkMatchingCode = () => {
    const codeData = [...new Set(data)].sort();
    const codeDataEmployeeSelect = [...new Set(dataEmployeeSelect)].sort();

    return codeData.every((itemCodeData) =>
      codeDataEmployeeSelect.some(
        (itemCDE) => itemCDE.empcode === itemCodeData.code
      )
    );
  };

  const updateUniqueData = () => {
    const seenEmpcodes = new Set<string>();
    const uniqueData = dataEmployeeSelect.filter((item) => {
      if (!seenEmpcodes.has(item?.empcode ?? "")) {
        seenEmpcodes.add(item?.empcode ?? "");
        return true;
      }
      return false;
    });
    return uniqueData;
  };

  const getColumnVisibility = () => {
    if (workShiftDetails) {
      return {
        id: false,
        dateOfBirth: false,
        address: false,
        active: false,
        description: false,
        accountingCenterId: false,
        createDate: false,
      };
    } else {
      return {
        id: false,
        dateOfBirth: true,
        address: true,
        active: true,
        description: true,
        accountingCenterId: true,
        createDate: true,
      };
    }
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    if (workShiftDetails) {
      const handleResize = () => {
        // 160 là chiều cao của phần phân trang
        // headerHeight là chiều cao của phần header
        setHeight(window.innerHeight - (275 + headerHeight));
      };

      handleResize(); // Set initial height
      window.addEventListener("resize", handleResize); // Update height on window resize

      return () => {
        window.removeEventListener("resize", handleResize); // Clean up event listener
      };
    } else {
      const handleResize = () => {
        // 160 là chiều cao của phần phân trang
        // headerHeight là chiều cao của phần header
        setHeight(window.innerHeight - (160 + headerHeight));
      };

      handleResize(); // Set initial height
      window.addEventListener("resize", handleResize); // Update height on window resize

      return () => {
        window.removeEventListener("resize", handleResize); // Clean up event listener
      };
    }
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enablePagination: true,
    enableRowVirtualization: true,
    enableToolbarInternalActions: false,
    enableTopToolbar: false,
    enableColumnResizing: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: workShiftDetails ? false : true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code", "fullname"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 50,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      // isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "75"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility();
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [workShiftDetails, table]);

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        {!isOpenModal && (
          <>
            <Flex
              gap="md"
              justify={"space-between"}
              align="center"
              direction="row"
              wrap="wrap"
              w={"100%"}
            >
              <_breadcrumb></_breadcrumb>
              <Flex gap="md" align="center" direction="row" wrap="wrap">
                <Button
                  color="blue"
                  variant="light"
                  leftSection={<IconRefresh size={17} />}
                  bd="1px solid blue"
                  onClick={() => {
                    updateTools();
                  }}
                >
                  Đồng bộ dữ liệu nhân viên
                </Button>
                <Button
                  leftSection={<IconActivity size={14} />}
                  color="green"
                  variant="outline"
                  onClick={async () => {
                    await activeData(true);
                  }}
                  disabled={selectIds.length < 1}
                >
                  Hoạt động
                </Button>
                <Button
                  leftSection={<IconHandStop size={14} />}
                  color="red"
                  variant="outline"
                  onClick={async () => {
                    await activeData(false);
                  }}
                  disabled={selectIds.length < 1}
                >
                  Dừng hoạt động
                </Button>

                <Button
                  leftSection={<IconTrash size={14} />}
                  color="red"
                  variant="outline"
                  onClick={async () => {
                    await deletesData(selectIds);
                  }}
                  disabled={selectIds.length < 1}
                >
                  Xóa nhóm (đã chọn)
                </Button>
                {/* <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              disabled
              onClick={async () => {
                await createItem();
              }}
            >
              Thêm mới
            </Button> */}
              </Flex>
            </Flex>
          </>
        )}
        <Flex w={"100%"} justify={"space-between"} align={"center"}>
          <Grid mt={"10px"} w={workShiftDetails ? "80%" : "100%"}>
            <GridCol span={workShiftDetails ? sizeGridModal : sizeGrid}>
              {/* <Input
              w={"100%"}
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(e.target.value ?? "", "keySearch");
              }}
            /> */}
              <InputSearch
                width="100%"
                placeholder="Từ khoá"
                onSearch={fetchData}
                onChange={(value) => {
                  handleChangeSearchValue(value, "keySearch");
                }}
              />
            </GridCol>

            {workShiftDetails || isOpenModal ? (
              <></>
            ) : (
              <>
                <GridCol span={sizeGrid}>
                  <Select
                    searchable
                    clearable
                    placeholder="Chọn chi nhánh"
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    leftSection={<IconBuildingStore color="#15aabf" />}
                    nothingFoundMessage={"Loading..."}
                    data={dataBranch}
                    onChange={(value) => {
                      handleChangeSearchValue(value || "", "branchId");
                    }}
                    onClick={() => {
                      if (dataBranch.length === 0) {
                        fetchDataBranch();
                      }
                    }}
                  />
                </GridCol>
                <GridCol span={sizeGrid}>
                  <Select
                    searchable
                    clearable
                    placeholder="Chọn phòng ban"
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    leftSection={<IconBuilding color="#15aabf" />}
                    nothingFoundMessage={"Loading..."}
                    data={dataDepartment}
                    onChange={(value) => {
                      handleChangeSearchValue(value || "", "departmentId");
                    }}
                    onClick={() => {
                      if (dataDepartment.length === 0) {
                        fetchDataDepartment();
                      }
                    }}
                  />
                </GridCol>
                <GridCol span={workShiftDetails ? sizeGridModal : sizeGrid}>
                  <Select
                    placeholder={"Chọn quản lý"}
                    searchable
                    clearable
                    data={dataEmployee}
                    leftSection={<IconUserCode color="#15aabf" />}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    nothingFoundMessage={"Loading..."}
                    onChange={(value) =>
                      handleChangeSearchValue(value || "", "managerId")
                    }
                    onClick={() => {
                      if (dataEmployee.length === 0) {
                        fetchDataEmployee();
                      }
                    }}
                  />
                </GridCol>
              </>
            )}

            <GridCol span={workShiftDetails ? sizeGridModal : sizeGrid}>
              <Select
                placeholder={"Chọn chức vụ"}
                searchable
                clearable
                data={dataRole}
                leftSection={<IconUserCircle color="#15aabf" />}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                nothingFoundMessage={"Loading..."}
                onChange={(value) =>
                  handleChangeSearchValue(value || "", "roleId")
                }
                onClick={() => {
                  if (dataRole.length === 0) {
                    fetchDataRole();
                  }
                }}
              />
            </GridCol>

            <GridCol span={workShiftDetails ? sizeGridModal : sizeGrid}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </GridCol>
          </Grid>
          <Flex>
            {workShiftDetails ? (
              <Flex
                gap={"xs"}
                w={"100%"}
                h={"100%"}
                align={"center"}
                justify={"flex-end"}
              >
                {checkMatchingCode() === false ? (
                  <Button
                    color="violet"
                    variant="outline"
                    leftSection={<IconHandClick size={14} />}
                    onClick={() =>
                      setDataEmployeeSelect((prev: WorkShiftDetail[]) => [
                        ...prev,
                        ...(data?.map((item) => ({
                          id: 0,
                          shiftId: 0,
                          empid: item.id,
                          empcode: item.code,
                          empname: item.fullname,
                          quanity: 0,
                          attribute1: "A",
                          attribute2: item.departmentId?.toString() ?? "",
                          attribute3: item.departmentName?.toString() ?? "",
                          attribute4: item.roleId?.toString() ?? "",
                          attribute5: item.roleName?.toString() ?? "",
                          attribute6: "",
                          attribute7: "",
                          attribute8: "",
                          attribute9: "",
                          attribute10: "",
                        })) || []),
                      ])
                    }
                  >
                    Chọn tất cả
                  </Button>
                ) : (
                  <Button
                    color="red"
                    variant="outline"
                    onClick={() => setDataEmployeeSelect([])}
                    leftSection={<IconTrash size={14} />}
                  >
                    Xóa tất cả
                  </Button>
                )}
                <Button
                  color="green"
                  variant="outline"
                  leftSection={<IconCheck size={14} />}
                  onClick={() => {
                    setWorkShiftDetails(updateUniqueData());
                    modals.closeAll();
                  }}
                >
                  Xác nhận
                </Button>
              </Flex>
            ) : (
              <></>
            )}
          </Flex>
        </Flex>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default EmployeeModelView;
